import VueRouter from 'vue-router';
import cookies from 'js-cookie';
import { Base64 } from 'js-base64';
import { userInfo } from "@/services/vips";
import store from '@/store';
import { setPage } from '@/common/script/uploadThinkingData';
import wechat from '@/router/wechat';
import { isWechat } from "@/appApi";

export default function configRouter(router: VueRouter): void {
    router.beforeEach((to, from, next) => {

        if (to.name !== 'Auth') {
            let sessionid = to.query.sessionid;
            // 非APP端会存储localStorage
            const localSessionId = localStorage.getItem('sessionid');
            if (localSessionId && !sessionid) {
                sessionid = localSessionId;
                localStorage.removeItem('sessionid');
            }
            if (sessionid) {
                cookies.set('sessionid', sessionid);
            } else {
                // sessionid= 清除
                // if ('sessionid' in to.query) {
                //     console.log('remove')
                //     cookies.remove('sessionid');
                // }
            }

        } else {

            const secretSessionid = to.query.secret_sessionid;
            if (secretSessionid){
                let sessionid = '';
                for (let i = 0; i < secretSessionid.length; i++) {
                    if (i % 2 === 0) {
                        sessionid += secretSessionid[i];
                    }
                }
                if (sessionid) {
                    localStorage.setItem('sessionid', Base64.decode(sessionid) as string);
                }
                // localStorage.removeItem('referer');
            } else {
                localStorage.removeItem('sessionid');
                console.log('remove')
                cookies.remove('sessionid')
            }
            const referer = localStorage.getItem('referer');
            location.replace(referer as string);

        }
        if (to.meta && to.meta.title) {
            document.title = to.meta.title;
        } else {
            document.title = '沪学习';
        }
        next();
    });

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    router.afterEach((to) => {
        const meta: any = to.meta;
        userInfo().then(async (res: any)=> {
            //
            if (res.retcode === 'SUCC') {
                if (res.user_info.status === 'logout') {
                    await store.dispatch('setLoginStatus', false);
                } else {
                    await store.dispatch('setLoginStatus', true);
                }
                // 新老接口字段不一样
                if (res.user_info.current_vip_info) {
                    res.user_info.vip_detail = res.user_info.current_vip_info
                }
                await store.dispatch('setUserInfo', res.user_info);
            }
            await store.dispatch('setIsUserStatus', true)
            if (meta.tga) {
                setPage();
            }
        }).catch(() => {
            console.log('请求失败');
        })

        if (isWechat()) {
            wechat();
        }
    })

}
